import React, { memo } from 'react';

import { Box, Skeleton } from '@mui/material';

import { PUSH_NOTIFICATION_SKELETON_ROW_KEYS } from './PushNotificationSkeleton.constants';
import {
  skeletonBodyStyles,
  skeletonMetaStyles,
  skeletonRowStyles,
} from './PushNotificationSkeleton.styles';

const PushNotificationSkeleton = memo(() => (
  <>
    {PUSH_NOTIFICATION_SKELETON_ROW_KEYS.map(key => (
      <Box key={key} sx={skeletonRowStyles}>
        <Skeleton height={20} variant="circular" width={20} />
        <Box sx={skeletonBodyStyles}>
          <Skeleton height={14} variant="text" width="90%" />
          <Skeleton height={14} variant="text" width="65%" />
          <Box sx={skeletonMetaStyles}>
            <Skeleton height={12} variant="text" width={60} />
            <Skeleton height={12} variant="text" width={40} />
          </Box>
        </Box>
      </Box>
    ))}
  </>
));

export default PushNotificationSkeleton;
